/* eslint-disable react-hooks/exhaustive-deps */
import "./api";

import { Box, Container, Drawer } from "@material-ui/core";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { ErrorModal, Header } from "./components-molecules";
import {
  CollectionOrders,
  ForgotPassword,
  ShopSignIn,
  ResetPassword,
} from "./components-pages";
import { ITheme, colours, theme } from "./constants/theme";
import React, { useEffect } from "react";
import { roles } from "./utils/roles";
import { useDispatch, useSelector } from "react-redux";

import { AppMenu } from "./components-organisms";
import CssBaseline from "@material-ui/core/CssBaseline";
import { EnvironmentRibbon, PageTitle } from "./components-atoms";
import { ThemeProvider } from "@material-ui/core/styles";
import { clearError } from "./redux/actions/error";
import clsx from "clsx";
import { exceptions } from "./components-molecules/ErrorModal";
import { makeStyles } from "@material-ui/core/styles";

import NewCollectionOrder from "./components-pages/NewCollectionOrder";
import { CollectionOrder } from "./components-pages/CollectionOrder";
import { NotificationHandler } from "./utils/NotificationHandler";
import { GetProfile } from "./redux/actions/adminLogin";
import { CollectionDashboard } from "./components-pages/CollectionDashboard";
import CollectionOrderHubspotWidget from "./components-molecules/CollectionOrderHubspotWidget";
import { setupAuthInterceptor } from "./service/authService";

const RedirectToSignIn = () => {
  return <Redirect to={{ pathname: "/login" }} />;
};
const RedirectToOrders = ({ role, isCollectEnabled }: any) => {
  if (isCollectEnabled) {
    return <Redirect to={{ pathname: "/delivery-dashboard" }} />;
  }
  //For merchant shoplist should be the first landing page but this is removed for 1.42 release
  // eslint-disable-next-line no-lone-blocks
  {
    /* <Redirect to={{ pathname: "/merchant/shoplist" }} /> */
  }
  return role === "Merchant" ? (
    <Redirect to={{ pathname: "/merchant/orders" }} />
  ) : role === "Admin" ? (
    <Redirect to={{ pathname: "/admin/orders" }} />
  ) : (
    <Redirect to={{ pathname: "/orders" }} />
  );
};
const App: React.FC = (props: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const userLoggedIn = useSelector((state: any) => state.login.userLoggedIn);
  const role = useSelector((state: any) => state.login.role);
  const isCollectEnabled = useSelector(
    (state: any) => state.login.isCollectEnabled,
  );
  const [pendingOrdersLoading, queuedOrdersLoading, dispatchOrdersLoading] =
    useSelector((state: any) => [
      state.pendingOrders.loading,
      state.dispatchOrders.loading,
      state.queuedOrders.loading,
    ]);

  const errorModalVisible = useSelector(
    (state: any) => state.error.errorModalVisible,
  );
  const [errorMessage, errorTitle] = useSelector((state: any) => [
    state.error.errorMessage,
    state.error.errorTitle,
  ]);

  useEffect(() => {
    if (role) {
      dispatch(GetProfile());
    }
  }, [dispatch, role]);

  useEffect(() => {
    setupAuthInterceptor(dispatch);
  }, [dispatch]);

  const errorModalClose = () => {
    dispatch(clearError());
  };
  if (pendingOrdersLoading || queuedOrdersLoading || dispatchOrdersLoading) {
    document.body.style.overflowY = "scroll";
  } else {
    document.body.style.overflowY = "auto";
  }

  return (
    <>
      <BrowserRouter>
        <PageTitle/>
        <CssBaseline />
        {userLoggedIn ? <NotificationHandler /> : null}
        <ThemeProvider theme={theme}>
          <ErrorModal
            title={errorTitle}
            visible={
              errorModalVisible &&
              exceptions.every((message) => message !== errorMessage)
            }
            errorBody={errorMessage}
            onClose={errorModalClose}
          />
          <EnvironmentRibbon />
          {userLoggedIn ? (
            <>
              <Box className={clsx("App", classes.root)}>
                <Header isLoggedIn />

                <Box className={classes.appContainer}>
                  <Drawer
                    variant="permanent"
                    classes={{
                      paper: classes.drawerPaper,
                    }}
                  >
                    <AppMenu userState={userLoggedIn} />
                  </Drawer>
                  <main className={classes.content}>
                    <Container maxWidth="lg" className={classes.container}>
                      <Switch>
                        <Route
                          path="/"
                          exact
                          component={() => (
                            <RedirectToOrders
                              role={role}
                              isCollectEnabled={isCollectEnabled}
                            />
                          )}
                        />
                        {roles?.[role ?? "Shop"] &&
                          roles[role ?? "Shop"].routes.map(
                            (item: any, index: number) => (
                              <Route
                                key={index}
                                exact
                                path={item.route}
                                component={item.component}
                              />
                            ),
                          )}
                        {/* <Route exact path="/orders" component={Orders} />
                        <Route exact path="/shoplist" component={ShopList} />
                        <Route
                          exact
                          path="/shopdetails/:id"
                          component={ShopDetails}
                        />
                        <Route
                          path="/orders/:details/:id?"
                          component={OrderDetails}
                        />
                        <Route exact path="/returns" component={Returns} />
                        <Route
                          exact
                          path="/accountSettings"
                          component={AccountSettings}
                        /> */}
                        <Route
                          path="/delivery-orders"
                          component={CollectionOrders}
                        />
                        <Route
                          path="/delivery-order/:id"
                          component={CollectionOrder}
                        />
                        <Route
                          path="/new-delivery-order"
                          component={NewCollectionOrder}
                        />
                        <Route
                          path="/delivery-dashboard"
                          component={CollectionDashboard}
                        />
                        <Route>
                          <RedirectToOrders
                            role={role}
                            isCollectEnabled={isCollectEnabled}
                          />
                        </Route>
                      </Switch>
                    </Container>
                  </main>
                </Box>
              </Box>
            </>
          ) : (
            <Switch>
              <Route path="/" exact component={RedirectToSignIn} />
              <Route path="/login" exact component={ShopSignIn} />
              {/* <Route path="/admin" exact component={AdminSignIn} /> */}
              <Route path="/forgotPassword" exact component={ForgotPassword} />
              <Route path="/resetPassword/:token" component={ResetPassword} />
              <Route component={RedirectToSignIn} />
            </Switch>
          )}

          {userLoggedIn && role !== "Admin" && <CollectionOrderHubspotWidget />}
        </ThemeProvider>
      </BrowserRouter>
    </>
  );
};

const sidenavWidth = 256;
const headerHeight = 64;

const useStyles = makeStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    marginLeft: sidenavWidth,
  },
  // Main app container
  appContainer: {
    display: "flex",
    flex: 1,
    height: "fit-content",
    marginTop: headerHeight,
  },
  // Sidenav
  drawerPaper: {
    width: sidenavWidth,
    height: "calc(100% - " + headerHeight + "px)",
    marginTop: headerHeight,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    whiteSpace: "nowrap",
    borderRight: "none",
    background: colours.highEmphasis,
  },
  content: {
    flexGrow: 1,
    overflow: "auto",
    backgroundColor: "#fff",
  },
  container: {
    paddingTop: theme.spacing(37 / 8),
    paddingBottom: theme.spacing(4),
  },
}));

export default App;
